import React, { createContext, useContext, useState, useEffect } from "react";
import { LOCAL_STORAGE_TOKENS } from "../utils/constants";

const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [firstloading, setFirstLoading] = useState(false);
  const { localKey_sessionHasVisited, localKey_userData } =
    LOCAL_STORAGE_TOKENS;

  useEffect(() => {
    const getLocalStorageData = localStorage.getItem(localKey_userData);
    const hasVisited = sessionStorage.getItem(localKey_sessionHasVisited);
    try {
      const parsedData = JSON.parse(getLocalStorageData);

      if (!hasVisited) {
        // Mark as visited for this session
        setFirstLoading(true);
        sessionStorage.setItem(localKey_sessionHasVisited, true);

        // Add any "first-load" actions you want to perform here
      }
      setUserData(parsedData);
    } catch (error) {
      console.error("Failed to parse userData from localStorage:", error);
      setUserData(null);
    } finally {
      setLoading(false); // Set loading to false after the data is processed
    }
  }, []);

  return (
    <DataContext.Provider
      value={{
        userData,
        setUserData,
        loading,
        setLoading,
        firstloading,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

export const useData = () => useContext(DataContext);
